/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : LegalRequirementTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomSearchbarWithApiV2 from "../../../components/customComponentsV2/common/searchBar/CustomSearchbarWithApiV2";
import { legalRequirements } from "../../../redux/actions";
import { componentStyle } from "../../../config/appTheme";
import LegalRequirementsCard from "./LegalRequirementsCard";
import { useSelector } from "react-redux";
import CustomSearchFilterV2 from "../../../components/customComponentsV2/common/searchBar/CustomSearchFilterV2";
import CustomPaginationV2 from "../../../components/customComponentsV2/common/pagination/CustomPaginationV2";

function LegalRequirementTemplate({
  linkedLegalRequirement,
  showCheckBox,
  searchKeys,
  unlinkLegalRequirement,
  selectedComponentDetails,
}) {

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(25);
  const [selectValue, setSelectValue] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);

  const handlePageChange = (selectedPage) => {
    setPage(selectedPage);

    let slicedData = filteredData.slice(
      (selectedPage - 1) * rowsPerPage,
      selectedPage * rowsPerPage
    );

    setPaginatedData(slicedData);
  };

  useEffect(() => {
    handlePageChange(1);
  }, [filteredData]);

  return (
    <Box>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item sx={{ mb: 2 }}>
          <Box>
            <Typography sx={{ ...componentStyle.font.tabLevelHeader }}>
              Linked Legal Requirement
            </Typography>
          </Box>
        </Grid>

        <Grid item>
          <Box sx={{ backgroundColor: "white" }}>
            <CustomSearchFilterV2
              placeholder="Search"
              searchKeys={searchKeys || []}
              getDataOnSearch={(filteredData) => {
                setFilteredData(filteredData);
              }}
              inputData={linkedLegalRequirement}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container sx={{ backgroundColor: "white" }}>
        <Grid item sm={12}>
          {paginatedData.length > 0 ? (
            <LegalRequirementsCard
              legalRequirementList={paginatedData}
              showCheckBox={showCheckBox}
              selectValue={selectValue}
              setSelectValue={setSelectValue}
              unlinkLegalRequirement={unlinkLegalRequirement}
              selectedComponentDetails={selectedComponentDetails}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "21rem",
              }}
            >
              <Typography>No Data</Typography>
            </Box>
          )}
        </Grid>
        <Grid item sx={{ width: "100%", p: 1 }}>
          <CustomPaginationV2
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handlePageChange}
            totalItems={filteredData.length}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default LegalRequirementTemplate;
